<template lang="html">
  <div class="slds-grid slds-wrap">

    <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagna($event)">
      <template v-slot:main>

<div class="slds-form" role="list">
  <div class="slds-form__row">
    <div class="slds-form__item" role="listitem">

    <fieldset class="slds-form-element slds-form-element_horizontal">
      <legend class="slds-form-element__legend slds-form-element__label">Ordinato/Spedito</legend>
      <div class="slds-form-element__control">
        <span class="slds-radio">
          <input type="radio" id="radio-41" value="ordinato" name="ordinato" checked="" v-model="tipodato" v-on:change="changeDato" />
          <label class="slds-radio__label" for="radio-41">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">Ordinato</span>
          </label>
        </span>
        <span class="slds-radio">
          <input type="radio" id="radio-42" value="spedito" name="ordinato" v-model="tipodato" v-on:change="changeDato" />
          <label class="slds-radio__label" for="radio-42">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">Spedito</span>
          </label>
        </span>
      </div>
    </fieldset>
    </div>

    <div class="slds-form__item" role="listitem">
    <fieldset class="slds-form-element slds-form-element_horizontal">
      <legend class="slds-form-element__legend slds-form-element__label">Quantità/Valore</legend>
      <div class="slds-form-element__control">
        <span class="slds-radio">
          <input type="radio" id="radio-43" value="quantità" name="valore" checked="" v-model="tipovalore" v-on:change="changeValore" v-bind:disabled="tipodato!='ordinato'"/>
          <label class="slds-radio__label" for="radio-43">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">Quantità</span>
          </label>
        </span>
        <span class="slds-radio">
          <input type="radio" id="radio-44" value="valore" name="valore" v-model="tipovalore" v-on:change="changeValore"  v-bind:disabled="tipodato!='ordinato'"/>
          <label class="slds-radio__label" for="radio-44">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">Valore</span>
          </label>
        </span>
      </div>
    </fieldset>
    </div>
  </div>
</div>
        <gnetTable
          v-bind:wrapheader="true"
          v-bind:cols="cols"
          v-bind:records="rows"
          v-on:filter="filterCol($event)"
          v-on:row="filterRow($event)"
          v-on:click="gotoRecord($event)"
        ></gnetTable>
      </template>
    </gnetTabs>

    <spinner v-bind:busy="busy"></spinner>

  </div>
</template>

<script>
import apiclient from '@/apiclient.js'
import gnetTable from '../components/table.vue'
import gnetTabs from '../components/tabs.vue'
import spinner from '../components/spinner.vue'

export default {
  name: 'ordini',
  components: {
    gnetTable,
    gnetTabs,
    spinner
  },
  props: {

  },
  data() {
    return {
      tipovalore: "quantità",
      tipodato: "ordinato",

      campagna:0,
      busy: false,

      records:[],
      cols:[],
      rows:[],

      filteredCol: -1,
      filteredRow: -1,

      fieldsstring: '',
      filterPanel: {
        show: false,
        value:'',
        name:'',
        index:0,
        filterCol: {}
      }
    }
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    }
  },
  watch: {
    actualdealer: function() {
      this.busy=true;
      this.getRecords();
    }
  },
  created: function() {
  },
  mounted: function() {
    if (!this.campagna) this.campagna=this.$store.state.campagne[0];
    this.busy=true;
    this.getRecords();
  },
  methods: {    
    gotoRecord: function(record) {
      console.log('gotoRecord'+record.Id);
      this.$router.push({ name:'CustomerForm', params: { id: record.Id, record: record } });
    },
    changeDato: function() {
      console.log(this.tipodato);
      this.filteredCol=-1;
      this.busy=true;
      this.getRecords();
    },
    changeValore: function() {
      console.log(this.tipovalore);
      this.getCols();      
    },
    changeCampagna: function(index) {
      console.log('changeCampagna');
      console.log(index);
      this.campagna=this.$store.state.campagne[index];
      this.busy=true;
      this.getRecords();
    },
    filterCol: function(index) {
      console.log('filter:'+index);
      if (this.filteredCol<0) {
        this.filteredCol=index;
      } else {
        this.filteredCol=-1;
      }
      this.getCols();      
    },
    filterRow: function(index) {
      console.log('filter:'+index);
      if (this.filteredRow<0) {
        this.filteredRow=index;
      } else {
        this.filteredRow=-1;
      }
      this.getCols();      
    },
    getCols: function() {
      this.cols.splice(0,this.cols.length);
      this.rows.splice(0,this.rows.length);

      var actualRow={};
      var c=new Set();
      var totali={ totale:0};
      this.records.forEach(function(d) {
        if (d.linea) {
          if (d.linea.includes('.')) {
            d.linea=d.linea.replace('.','_')
          }
          c.add(d.linea);
          if (actualRow['custaccount']!=d.custaccount) {
            if (actualRow['custaccount']) { this.rows.push(actualRow); }
            actualRow={ Id: d.custaccount, custaccount: d.custaccount, nome_cliente: d.nome_cliente, totale:0};
          }
          if (this.tipodato!="ordinato") {
            if (actualRow['cod_ordine']!=d.cod_ordine) {
              actualRow={ Id: d.custaccount, custaccount: d.custaccount, nome_cliente: d.nome_cliente, cod_ordine: d.cod_ordine};
            }
          }
          if (this.tipodato=="ordinato") {
            if (this.tipovalore=="valore")
              actualRow[d.linea]=d.tot_ordinato;
            else
              actualRow[d.linea]=d.tot_qty;

            if (!totali[d.linea]) totali[d.linea]=0;
            totali[d.linea]+=actualRow[d.linea];
            totali.totale+=actualRow[d.linea];

            actualRow.totale+=actualRow[d.linea];
          } else {
            actualRow[d.linea]=d.stato_spedizione;
          }          
        }
      }, this)

      this.rows.push(actualRow);

      this.rows.push(totali);

      if (this.filteredRow>=0) {
        console.log('trim rows:'+this.filteredRow)
        this.rows.splice(this.filteredRow+1, this.rows.length)
        this.rows.splice(0, this.filteredRow)
      }


      var colnames=[]
      var iter=c.entries();
      for (var v of iter) {
        colnames.push( { name: v[0], label: v[0], 
          type: (this.tipodato=="ordinato"?( this.tipovalore=="valore"?'currency':'decimal'):'text') 
        } )
      }
      colnames.sort(function(a,b) {
        if (a.label>b.label) return 1;
        return -1;
      });
      if (this.filteredCol<0) {
        this.cols=colnames;
      } else {
        this.cols=[ colnames[this.filteredCol-2-(this.tipodato!="ordinato"?1:0)] ];
        this.cols[0]['filtered']=true;
      }
      this.cols.splice(0,0, { name: 'custaccount', label: 'Codice'} )
      this.cols.splice(1,0, { name: 'nome_cliente', label: 'Cliente', type:'truncate'} )
      if (this.tipodato!="ordinato") {
        this.cols.splice(2,0, { name: 'cod_ordine', label: 'Ordine', type:'truncate'} )   
      } else {
        this.cols.splice(2,0, { name: 'totale', label: 'Totale',
          type: (this.tipodato=="ordinato"?( this.tipovalore=="valore"?'currency':'decimal'):'text') 
        } )   
      }
    },
    getRecords: function() {
      console.log('campagna')
      console.log(this.campagna)
      var anno_cc=this.campagna.substr(0,4);
      var cc=this.campagna.substr(5,2);

      console.log(anno_cc)
      console.log(cc)

      var self=this;
      var sql='';
      if (this.tipodato=="ordinato") {
        sql='SELECT custaccount, nome_cliente , linea, sum(qty) as tot_qty, round(sum(totale_no_oma),2) as tot_ordinato  '
        sql+='FROM `fcpanini-208106.ax.20200511__ordini_con_prodotti`  '
        sql+="where cc like '"+cc+"' and anno_cc ="+anno_cc+" and zona1 like '"+this.$store.getters.zona+"' ";
        sql+='group by custaccount, nome_cliente , linea '
        sql+='order by nome_cliente, linea'
      } else {
        sql="SELECT cod_ordine, custaccount, nome_cliente, zona1 as agente, linea, "
        sql+="case "
        sql+="when salesid is not null and stato_riga like 'Aperto' then 'Parz. Spedito'  "
        sql+="when trim(stato_riga) like 'Fatturato' or trim(stato_riga) like 'Consegnato' then 'Spedito' "
        sql+="when salesid is null and stato_riga like 'Aperto' then 'Non Spedito' "
        sql+="when stato_riga like 'Annullato' then 'Annullato' "
        sql+="end as stato_spedizione, "
        sql+="FROM `fcpanini-208106.ax.20200511__ordini_con_prodotti`  left join `ax.CUSTPACKINGSLIPTRANS` ON (cod_ordine = salesid  and `fcpanini-208106.ax.20200511__ordini_con_prodotti`.itemid = `ax.CUSTPACKINGSLIPTRANS`.itemid ) "
        sql+="where cc like '"+cc+"' and anno_cc ="+anno_cc+" and zona1 like '"+this.$store.getters.zona+"' ";
        sql+="group by cod_ordine, custaccount, nome_cliente, agente, linea, stato_spedizione "
        sql+='order by nome_cliente, cod_ordine, linea'
      }

/*
SELECT cod_ordine, custaccount, nome_cliente, zona1 as agente, linea, 
case
when salesid is not null and stato_riga like 'Aperto'  then 'Parzialmente Spedito' 
when trim(stato_riga) like 'Fatturato' or trim(stato_riga) like 'Consegnato'  then 'Spedito' 
when salesid is null and stato_riga like 'Aperto' then 'Non Spedito' 
when stato_riga like 'Annullato' then 'Annullato'
end as stato_spedizione,
FROM `fcpanini-208106.qlik.20200511__ordini_con_prodotti`  left join `ax.CUSTPACKINGSLIPTRANS` ON (cod_ordine = salesid  and    `fcpanini-208106.qlik.20200511__ordini_con_prodotti` .itemid = `ax.CUSTPACKINGSLIPTRANS`.itemid  )
WHERE CC LIKE 'NA' AND ANNO_CC = 2019 and zona1 like '701'
group by   cod_ordine, custaccount, nome_cliente, agente, linea, stato_spedizione 
*/
      
      console.log(sql);
      apiclient.getBQ(this.$store.getters.connection, sql)
        .then(function(records) {
          self.records=records;
          console.log(records.length);
          self.getCols();
          self.busy=false;
        });
    },    

  }
}
</script>

<style scoped>

</style>
